export function UnconfiguredWorkspacePanel({ workspace }) {
  const workspaceName = workspace?.roleLabel || 'This workspace';
  const userIdEnv = workspace?.userIdEnv;
  const orgIdEnv = workspace?.orgIdEnv;

  return (
    <section className="rounded-2xl border border-eorig-border bg-white p-6 shadow-eorig-card">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-eorig-muted">
        Demo workspace
      </p>
      <h2 className="mt-2 text-lg font-semibold text-eorig-ink">
        Demo workspace is not configured
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-eorig-muted">
        Configure the workspace identity to continue. {workspaceName} needs a
        backend user and organization ID before API calls can be sent.
      </p>
      {userIdEnv && orgIdEnv ? (
        <p className="mt-3 text-xs leading-relaxed text-eorig-muted">
          Set <span className="font-mono text-eorig-ink">{userIdEnv}</span> and{' '}
          <span className="font-mono text-eorig-ink">{orgIdEnv}</span> in the
          frontend environment, then stop and restart <span className="font-mono text-eorig-ink">npm start</span>.
          Create React App only reads these values when the dev server starts.
          Do not invent identifiers.
        </p>
      ) : null}
    </section>
  );
}
